import { FC, FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "@mui/material";
import {
  ModalButton,
  CloseModalButton,
  BackModalButton,
} from "components/Buttons";
import { AppText } from "components";
import { normolizeDecimalsWithNoCode } from "helpers/funcs";
import StakeMillionRows from "pages/EarningPage/components/StakeMillionRows";
import { colors, currencyIcons } from "helpers/consts";
import type { CurrencyInterface } from "helpers/types";
import {
  ModalContent,
  InnerContentForm,
  ModalHeading,
  ConfirmBlock,
  ConfirmInfo,
} from "../styled";

interface ConfirmMillionStakeStepProps {
  onClose: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  currencyValue: string;
  currencies: CurrencyInterface[] | null;
}

const ConfirmMillionStakeStep: FC<ConfirmMillionStakeStepProps> = ({
  onClose,
  currencyValue,
  currencies,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={500}>
      <ModalContent>
        <ModalHeading $centered>Golden Million confirmation</ModalHeading>
        <CloseModalButton onClose={onClose} />
        <BackModalButton onBack={onClose} />

        <InnerContentForm onSubmit={(e) => onSubmit(e)}>
          <ConfirmBlock>
            {currencyIcons["USDT"]}
            <AppText
              fontSize={20}
              fontWeight={600}
              color={colors.gray_700}
              lineHeight={30}
            >
              {normolizeDecimalsWithNoCode(
                Number(currencyValue),
                "USDT",
                currencies
              )}
              <AppText
                isSpan
                fontSize={20}
                fontWeight={600}
                color={colors.gray_400}
                lineHeight={30}
              >
                {" "}
                {"USDT"}
              </AppText>
            </AppText>
            <ConfirmInfo>
              <AppText fontWeight={400} color={colors.gray_700}>
                {t("STAKE_CONFIRM")} USDT?
              </AppText>
            </ConfirmInfo>
          </ConfirmBlock>

          <StakeMillionRows
            currencyValue={currencyValue}
            currencies={currencies}
          />

          <ModalButton type="submit">{t("CONFIRM")}</ModalButton>
        </InnerContentForm>
      </ModalContent>
    </Fade>
  );
};

export default ConfirmMillionStakeStep;
